"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabPanel = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var TabPanel_style_1 = require("./TabPanel.style");
var core_1 = require("@material-ui/core");
var TabPanel = function (_a) {
    var children = _a.children, value = _a.value, index = _a.index, _b = _a.fullHeight, fullHeight = _b === void 0 ? false : _b;
    var classes = (0, TabPanel_style_1.useTabPanelStyles)();
    var isVisible = value === index;
    var FADE_IN_TIME = 2000;
    return (react_1.default.createElement("div", { hidden: !isVisible, "data-signa": "tab-panel-".concat(value), className: "".concat(classes.container, " ").concat(fullHeight ? classes.fullHeight : '') }, isVisible && (react_1.default.createElement(core_1.Fade, { in: isVisible, timeout: FADE_IN_TIME },
        react_1.default.createElement(core_1.Box, { p: 3, className: classes.root }, children)))));
};
exports.TabPanel = TabPanel;
